





















import { createComponent, watch, ref, computed } from "@vue/composition-api";
import {
  useStringValidation,
  formatValidationResponse
} from "@web-components/compositions/useStringValidation";
import { useAutoFillFix } from "@web-components/compositions/useAutoFillFix";
import { halfPostcodeRegEx, postcodeRegEx } from "@web-components/common/regex";

interface BasePostCodeInputProps {
  value?: string;
  required?: boolean;
  allowHalfPostcodes?: boolean;
}

export default createComponent({
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    allowHalfPostcodes: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    }
  },
  setup(props: Readonly<BasePostCodeInputProps>, context) {
    let inputValue = ref(props.value || "");
    const showErrorMessage = ref(false);

    const validationResponse = useStringValidation({
      inputRef: inputValue,
      required: props.required,
      regex: props.allowHalfPostcodes ? halfPostcodeRegEx : postcodeRegEx
    });

    watch([inputValue, validationResponse.valid], ([_, a]: any) => {
      context.emit("validation", formatValidationResponse(validationResponse));
    });

    const onKeyUp = (value: string) => {
      showErrorMessage.value = false;
      inputValue.value = value;
      validationResponse.setDirty(true);
      context.emit("input", value);
    };

    const { inputRef } = useAutoFillFix(inputValue, onKeyUp);

    const isError = computed(() => {
      return (
        validationResponse.regexError.value ||
        validationResponse.requiredError.value
      );
    });

    const onBlur = () => {
      showErrorMessage.value = isError.value;
    };

    return {
      onKeyUp,
      onBlur,
      showErrorMessage,
      inputRef,
      isError
    };
  }
});
